module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Déplacer un lieu dans la liste pour définir son ordre","btnCancel":"Annuler","btnSave":"Enregistrer"},"en":{"title":"Drag a POI in the list to reorder it","btnCancel":"Cancel","btnSave":"Save"}}')
  delete Component.options._Ctor
}
